import React, {  useContext} from "react";
import TradathonContext from "../../context/tradathon/TradathonContext";
import NumberFormat from "react-number-format";
import { formatPrice } from "../../helpers/format";
import CryptoContext from "../../context/crypto/cryptoContext";
import ParameterContext from "../../context/parameter/parameterContext";
import { AiOutlineCaretDown, AiFillCaretUp } from "react-icons/ai";
import TradathonDropdown from "../../components/TradathonDropdown";
import moment from "moment";
import { BsFillLockFill, BsThreeDotsVertical } from "react-icons/bs";
import VTradingContext from "../../context/vTrading/VTradingContext";
import SellAlert from "../../components/SellAlert";
import TradathonModal from "../../components/TradathonModal";
import Price from "../../components/Price";
import { FaInfoCircle } from "react-icons/fa";
import ReactTooltip from "react-tooltip";
const ShowCoins = ({ history, location }) => {
  const loading = false;

  const {
    coins,
    tradathonModal,
    activeRoom,

    tradathonLoading,
  } = useContext(TradathonContext);
  const { vtButton } = useContext(ParameterContext);
  const { vtradingAlertModal } = useContext(VTradingContext);

  const handleClick = (id) => {
    history?.push(`/cryptos/${id}`);
  };
  const { livePriceData,  cryptoData, exchangeRate, currencySymbol } =
    useContext(CryptoContext);

  return (
    <>
      {tradathonModal && <TradathonModal from="addcoins" />}
      {vtradingAlertModal && <SellAlert type="tradathon" />}

      <div
        className="VtradingScreen2__TableContainer"
        style={{ background: "#EFF2F5" }}
      >
        {activeRoom && activeRoom.room.rstatus === 0 ? (
          <table className="Home__MainTable">
            <thead>
              <tr>
                <th></th>

                <th style={{ textAlign: "left" }}>
                  <div className="Home__MainTable-th">
                    <div
                      style={{
                        color: "white",
                      }}
                      className="Home__MainTable__pct"
                    >
                      &nbsp;
                      <div style={{ cursor: "pointer" }}>Coin</div>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="Home__MainTable-th">
                    <div
                      style={{
                        color: "white",
                      }}
                      className="Home__MainTable__pct"
                    >
                      &nbsp;
                      <p style={{ marginRight: "5px" }}>
                        Quantity <ReactTooltip place="top" effect="float" />{" "}
                      </p>
                      <FaInfoCircle
                        size={20}
                        data-tip="It will be available when contest becomes live"
                      />
                    </div>
                  </div>
                </th>
                <th>
                  <div className="Home__MainTable-th">
                    <div
                      style={{
                        color: "white",
                      }}
                      className="Home__MainTable__pct"
                    >
                      &nbsp;
                      <div style={{ cursor: "pointer" }}>Total Investment</div>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="Home__MainTable-th">
                    <div
                      style={{
                        color: "white",
                      }}
                      className="Home__MainTable__pct"
                    >
                      &nbsp;
                      <p style={{ marginRight: "5px" }}>
                        Average Price{" "}
                        <ReactTooltip place="top" effect="float" />{" "}
                      </p>
                      <FaInfoCircle
                        size={20}
                        data-tip="It will be available when contest becomes live"
                      />
                    </div>
                  </div>
                </th>
                <th>
                  <div className="Home__MainTable-th">
                    <div
                      style={{
                        color: "white",
                      }}
                      className="Home__MainTable__pct"
                    >
                      &nbsp;
                      <div style={{ cursor: "pointer" }}>Current Value</div>
                    </div>
                  </div>
                </th>
                <th>
                  <div className="Home__MainTable-th">
                    <div
                      style={{
                        color: "white",
                      }}
                      className="Home__MainTable__pct"
                    >
                      &nbsp;
                      <p style={{ marginRight: "5px" }}>
                        P & L <ReactTooltip place="top" effect="float" />{" "}
                      </p>
                      <FaInfoCircle
                        size={20}
                        data-tip="It will be available when contest becomes live"
                      />
                    </div>
                  </div>
                </th>
                <th>
                  <div className="Home__MainTable-th">
                    <p style={{ marginRight: "5px" }}>
                      % Ch <ReactTooltip place="top" effect="float" />{" "}
                    </p>
                    <FaInfoCircle
                      size={20}
                      data-tip="It will be available when contest becomes live"
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {coins && coins.length > 0 ? (
                coins.map((c) => (
                  <>
                    <tr key={c._id} className="Home__MainTable__link">
                      <td style={{ textAlign: "left" }}>
                        {tradathonLoading ? (
                          <div
                            className="skeleton text"
                            style={{ width: "40px" }}
                          />
                        ) : (
                          <TradathonDropdown
                            amount={c.amount}
                            price={formatPrice(c.invAmount / c.amount)}
                            id={c.symbol}
                            invested={c.cstAmount}
                            coinId={c._id}
                            marketPrice={livePriceData[c.symbol]}
                            type="before"
                          />
                        )}
                      </td>

                      <td style={{ textAlign: "left" }}>
                        <div className="Home__MainTable-td">
                          {tradathonLoading ? (
                            <div
                              className="skeleton text"
                              style={{ width: "120px" }}
                            />
                          ) : (
                            <p
                              style={{
                                marginRight: "5px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              {c.cname}
                            </p>
                          )}
                        </div>
                      </td>
                      <td style={{ textAlign: "left" }}>
                        <div className="Home__MainTable-td">
                          {tradathonLoading ? (
                            <div
                              className="skeleton text"
                              style={{ width: "120px" }}
                            />
                          ) : (
                            <>
                              {" "}
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleClick(c.id)}
                              >
                                Not Available
                              </p>
                            </>
                          )}
                        </div>
                      </td>
                      <td>
                        <div
                          className="Home__MainTable-td"
                          style={{
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                          }}
                          onClick={() => handleClick(c.id)}
                        >
                          <div>
                            {tradathonLoading ? (
                              <div
                                className="skeleton text"
                                style={{ width: "120px" }}
                              />
                            ) : (
                              <NumberFormat
                                value={formatPrice(c.cstAmount / exchangeRate)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={currencySymbol}
                              />
                            )}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div
                          className="Home__MainTable-td"
                          style={{
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                          }}
                          onClick={() => handleClick(c.id)}
                        >
                          {tradathonLoading ? (
                            <div
                              className="skeleton text"
                              style={{ width: "120px" }}
                            />
                          ) : (
                            <>
                              {" "}
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleClick(c.id)}
                              >
                                Not Available
                              </p>
                            </>
                          )}
                        </div>
                      </td>
                      {tradathonLoading ? (
                        <td>
                          {" "}
                          <div
                            className="Home__MainTable-td"
                            style={{
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            onClick={() => handleClick(c.id)}
                          >
                            <div
                              className="skeleton text"
                              style={{ width: "120px" }}
                            />
                          </div>
                        </td>
                      ) : (
                        <Price
                          id={c.cname}
                          item={
                            cryptoData &&
                            cryptoData.length > 0 &&
                            cryptoData.filter((d) => d.currency === c.cname)[0]
                              .price
                          }
                          property="price"
                          style2={{
                            justifyContent: "flex-start",
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                          }}
                          style1={{ textAlign: "right" }}
                        />
                      )}
                      <td>
                        <div
                          className="Home__MainTable-td"
                          style={{
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                          }}
                          onClick={() => handleClick(c.id)}
                        >
                          {tradathonLoading ? (
                            <div
                              className="skeleton text"
                              style={{ width: "120px" }}
                            />
                          ) : (
                            <>
                              {" "}
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleClick(c.id)}
                              >
                                Not Available
                              </p>
                            </>
                          )}
                        </div>
                      </td>
                      <td>
                        {tradathonLoading ? (
                          <div
                            className="skeleton text"
                            style={{ width: "120px" }}
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                              width: "120px",
                            }}
                          >
                            {" "}
                            <p
                              style={{
                                marginLeft: "15px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              Not Available
                            </p>
                          </div>
                        )}
                      </td>
                    </tr>
                  </>
                ))
              ) : (
                <></>
              )}
            </tbody>
          </table>
        ) : (
          activeRoom &&
          activeRoom.room.rstatus !== 0 &&
          (vtButton === "position" ? (
            <table className="Home__MainTable">
              <thead>
                <tr>
                  {activeRoom && activeRoom.room.rstatus !== 2 && <th></th>}

                  <th style={{ textAlign: "left" }}>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Coin</div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Quantity</div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>
                          Total Investment
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Average Price</div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Current Price</div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>P & L</div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="Home__MainTable-th">
                      <div>
                        <p>% Ch</p>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {coins && coins.length > 0 && !loading ? (
                  coins.map((c) => (
                    <>
                      <tr key={c._id} className="Home__MainTable__link">
                        {activeRoom && activeRoom.room.rstatus !== 2 && (
                          <td style={{ textAlign: "left" }}>
                            {tradathonLoading ? (
                              <div
                                className="skeleton text"
                                style={{ width: "200px" }}
                              />
                            ) : (
                              <TradathonDropdown
                                amount={c.quantity}
                                invested={c.investedAmt}
                                id={c.cname}
                                marketPrice={livePriceData[c.cname]}
                                type="position"
                                orderType={c.type}
                                coinId={c._id}
                              />
                            )}
                          </td>
                        )}
                        <td style={{ textAlign: "left" }}>
                          <div className="Home__MainTable-td">
                            {tradathonLoading ? (
                              <div
                                className="skeleton text"
                                style={{ width: "200px" }}
                              />
                            ) : (
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleClick(c.id)}
                              >
                                {c.cname}
                              </p>
                            )}
                          </div>
                        </td>
                        <td style={{ textAlign: "left" }}>
                          <div className="Home__MainTable-td">
                            <p
                              style={{
                                marginRight: "5px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              {c.quantity - (c.lockQty ? c.lockQty : 0)}
                              {c.lockQty > 0 && (
                                <>
                                  (
                                  <BsFillLockFill
                                    style={{ color: "#8d0782" }}
                                    data-tip="Lock Quantity"
                                  />
                                  <span data-tip="Lock Quantity">
                                    {formatPrice(c.lockQty)}
                                    <ReactTooltip
                                      place="top"
                                      effect="float"
                                      style={{ color: "#8d0782" }}
                                    />
                                  </span>
                                  )
                                </>
                              )}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div
                            className="Home__MainTable-td"
                            style={{
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            onClick={() => handleClick(c.id)}
                          >
                            <div>
                              <NumberFormat
                                value={formatPrice(
                                  c.investedAmt / exchangeRate
                                )}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={currencySymbol}
                              />
                            </div>
                          </div>
                        </td>

                        <td>
                          <div
                            className="Home__MainTable-td"
                            style={{
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            onClick={() => handleClick(c.id)}
                          >
                            <div>
                              <NumberFormat
                                value={formatPrice(c.avgPrice / exchangeRate)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={currencySymbol}
                              />
                            </div>
                          </div>
                        </td>

                        {activeRoom.room.rstatus === 2 ? (
                          <td>
                            <div
                              className="Home__MainTable-td"
                              style={{
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              <div>
                                <NumberFormat
                                  value={formatPrice(
                                    (c.currPrice * c.quantity) / exchangeRate
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={currencySymbol}
                                />
                              </div>
                            </div>
                          </td>
                        ) : (
                          <Price
                            id={c.cname}
                            item={c.avgPrice}
                            property="price"
                            style2={{
                              justifyContent: "flex-start",
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            style1={{ textAlign: "right" }}
                          />
                        )}

                        <td>
                          <div
                            className="Home__MainTable-td"
                            style={{
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            onClick={() => handleClick(c.id)}
                          >
                            <div>
                              {activeRoom.room.rstatus === 2 ? (
                                <NumberFormat
                                  value={formatPrice(
                                    Math.abs(
                                      (c.currPrice * c.quantity -
                                        c.investedAmt) /
                                        exchangeRate
                                    )
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={currencySymbol}
                                />
                              ) : (
                                <NumberFormat
                                  value={formatPrice(
                                    ((livePriceData
                                      ? livePriceData[c.cname] * exchangeRate
                                      : c.avgPrice) *
                                      c.quantity -
                                      c.investedAmt) /
                                      exchangeRate
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={currencySymbol}
                                />
                              )}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            style={{
                              color:
                                activeRoom.room.rstatus === 2
                                  ? Number(
                                      c.currPrice * c.quantity - c.investedAmt
                                    ) > 0
                                    ? "rgba(69, 170, 67, 1)"
                                    : "rgba(233, 56, 72, 1)"
                                  : Number(
                                      (livePriceData
                                        ? livePriceData[c.cname] * exchangeRate
                                        : c.avgPrice) *
                                        c.quantity -
                                        c.investedAmt
                                    ) > 0
                                  ? "rgba(69, 170, 67, 1)"
                                  : "rgba(233, 56, 72, 1)",
                            }}
                            className="Home__MainTable__pct"
                          >
                            {activeRoom.room.rstatus === 2 ? (
                              c.currPrice * c.quantity - c.investedAmt > 0 ? (
                                <AiFillCaretUp className="Home__MainTable__pcticon" />
                              ) : (
                                <>
                                  {" "}
                                  <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                                </>
                              )
                            ) : (livePriceData
                                ? livePriceData[c.cname] * exchangeRate
                                : c.avgPrice) *
                                c.quantity -
                                c.investedAmt >
                              0 ? (
                              <AiFillCaretUp className="Home__MainTable__pcticon" />
                            ) : (
                              <>
                                <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                              </>
                            )}
                            {activeRoom.room.rstatus === 2 ? (
                              <NumberFormat
                                value={formatPrice(
                                  (Math.abs(
                                    c.currPrice * c.quantity - c.investedAmt
                                  ) /
                                    c.investedAmt) *
                                    100
                                )}
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                            ) : (
                              <NumberFormat
                                value={formatPrice(
                                  Math.abs(
                                    ((livePriceData
                                      ? livePriceData[c.cname] * exchangeRate
                                      : c.avgPrice) *
                                      c.quantity -
                                      c.investedAmt) /
                                      c.investedAmt
                                  ) * 100
                                )}
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                            )}
                            %
                          </div>
                        </td>
                      </tr>
                    </>
                  ))
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          ) : activeRoom &&
            activeRoom.room.rstatus !== 0 &&
            vtButton === "history" ? (
            <table className="Home__MainTable">
              <thead>
                <tr>
                  {activeRoom && activeRoom.room.rstatus !== 2 && <th></th>}
                  <th style={{ textAlign: "left" }}>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Type</div>
                      </div>
                    </div>
                  </th>
                  <th style={{ textAlign: "left" }}>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Coin</div>
                      </div>
                    </div>
                  </th>

                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div onClick={() => {}} style={{ cursor: "pointer" }}>
                          Quantity
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Price</div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Total Val</div>
                      </div>
                    </div>
                  </th>

                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Time</div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {coins && coins.length > 0 && !loading ? (
                  coins.map((c) => (
                    <>
                      <tr key={c._id} className="Home__MainTable__link">
                        {activeRoom && activeRoom.room.rstatus !== 2 && (
                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <BsThreeDotsVertical />
                            </div>
                          </td>
                        )}
                        <td style={{ textAlign: "left" }}>
                          <div className="Home__MainTable-td">
                            <p
                              style={{
                                marginRight: "5px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                                color:
                                  c.status === 4
                                    ? "rgba(233, 56, 72, 1)"
                                    : c.type === "buy"
                                    ? "rgba(69, 170, 67, 1)"
                                    : "rgba(233, 56, 72, 1)",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              {c.status === 4 ? "cancel" : c.type}
                            </p>
                          </div>
                        </td>
                        <td style={{ textAlign: "left" }}>
                          <div className="Home__MainTable-td">
                            <p
                              style={{
                                marginRight: "5px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              {c.symbol}
                            </p>
                          </div>
                        </td>
                        <td style={{ textAlign: "left" }}>
                          <div className="Home__MainTable-td">
                            <p
                              style={{
                                marginRight: "5px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              {c.quantity}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div
                            className="Home__MainTable-td"
                            style={{
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            onClick={() => handleClick(c.id)}
                          >
                            <div>
                              <NumberFormat
                                value={formatPrice(c.price / exchangeRate)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={currencySymbol}
                              />
                            </div>
                          </div>
                        </td>

                        <td>
                          <div
                            className="Home__MainTable-td"
                            style={{
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            onClick={() => handleClick(c.id)}
                          >
                            <div>
                              <NumberFormat
                                value={
                                  c.total >= 0 &&
                                  formatPrice(c.total / exchangeRate)
                                }
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={currencySymbol}
                              />
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            className="Home__MainTable-td"
                            style={{
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            onClick={() => handleClick(c.id)}
                          >
                            <div>
                              {moment(c.updatedAt).format(
                                "MMMM Do YYYY, h:mm:ss a"
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </>
                  ))
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          ) : (
            <table className="Home__MainTable">
              <thead>
                <tr>
                  {activeRoom && activeRoom.room.rstatus !== 2 && <th></th>}
                  <th style={{ textAlign: "left" }}>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Type</div>
                      </div>
                    </div>
                  </th>
                  <th style={{ textAlign: "left" }}>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Coin</div>
                      </div>
                    </div>
                  </th>

                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Quantity</div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>
                          Total Investment
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="Home__MainTable-th">
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Trigger Price</div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {coins && coins.length > 0 && !loading ? (
                  coins.map((c) => (
                    <>
                      <tr key={c._id} className="Home__MainTable__link">
                        {activeRoom && activeRoom.room.rstatus !== 2 && (
                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <TradathonDropdown
                                amount={c.quantity}
                                invested={c.total}
                                id={c.symbol}
                                marketPrice={livePriceData[c.symbol]}
                                type="openOrder"
                                orderType={c.type}
                                orderId={c._id}
                              />
                            </div>
                          </td>
                        )}
                        <td style={{ textAlign: "left" }}>
                          <div className="Home__MainTable-td">
                            <p
                              style={{
                                marginRight: "5px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                                color:
                                  c.type === "buy"
                                    ? "rgba(69, 170, 67, 1)"
                                    : "rgba(233, 56, 72, 1)",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              {c.type}
                            </p>
                          </div>
                        </td>
                        <td style={{ textAlign: "left" }}>
                          <div className="Home__MainTable-td">
                            <p
                              style={{
                                marginRight: "5px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              {c.symbol}
                            </p>
                          </div>
                        </td>
                        <td style={{ textAlign: "left" }}>
                          <div className="Home__MainTable-td">
                            <p
                              style={{
                                marginRight: "5px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              {c.quantity}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div
                            className="Home__MainTable-td"
                            style={{
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            onClick={() => handleClick(c.id)}
                          >
                            <div>
                              <NumberFormat
                                value={formatPrice(c.total / exchangeRate)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={currencySymbol}
                              />
                            </div>
                          </div>
                        </td>

                        <td>
                          <div
                            className="Home__MainTable-td"
                            style={{
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            onClick={() => handleClick(c.id)}
                          >
                            <div>
                              <NumberFormat
                                value={formatPrice(c.price / exchangeRate)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={currencySymbol}
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </>
                  ))
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          ))
        )}
      </div>
    </>
  );
};

export default ShowCoins;
